/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-05-20 10:18:02
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-13 08:35:44
 */
import axios from 'axios'

const url = global.url
/**
 * gg
 * @returns 
 */
export async function getNotice() {
    return new Promise((resolve, reject) => {
        axios.get(url.news + '/notice/getNotices/3/1').then((res) => {
            let data = res.data
            if (data.code === '200') {
                resolve(data.payload) //返回一个数组  
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e) //reject 需要用catch 去接
        })
    })
}
/**
 * gg
 * @returns 
 */
 export async function getTraning(page,limit) {
    return new Promise((resolve, reject) => {
        axios.get(url.px + `/collection/page?page=${page}&limit=${limit}`).then((res) => {
            let data = res.data
            if (data.code == 200) {
                resolve(data.data.records) //返回一个数组  
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e) //reject 需要用catch 去接
        })
    })
}

